<template>
    <div class="order-comment-history">
        <span v-if="isLoading['commentHistory']">
            <span>
                Bezig met ophalen van notities&hellip;
            </span>
            <FontAwesomeIcon icon="spinner" spin class="ml-1" />
        </span>

        <span v-else-if="!commentHistory.length">
            Geen notities.
        </span>

        <BTable v-else :items="commentHistory" :fields="commentHistoryFields" sort-by="created_at" :sort-desc="sortingOptions.sortDesc">
            <template #table-colgroup="scope">
                <col style="width:10rem;">
                <col />
                <col style="min-width:16rem;">
            </template>
            <template #cell(created_at)="data">
                <span v-if="data.value">
                    {{ data.value | datetime }}
                    <small v-if="data.item.is_edited">
                        <font-awesome-icon icon="info" class="text-secondary ml-1 opacity-7"
                                           v-b-tooltip="`Bewerkt op ${DateHelper.datetime(data.item.updated_at)}`"
                        />
                    </small>
                </span>
                <span v-else>onbekend</span>
            </template>
            <template #cell(comment)="data">
                <div class="float-right" v-if="data.item.is_editable">
                    <b-button size="sm" variant="link" @click="$emit('edit', data.item)" class="p-0 pr-1">
                        <font-awesome-icon icon="pencil" class="text-info" size="sm" v-b-tooltip="`Notitie bewerken`"/>
                    </b-button>
                </div>

                <span v-html="newLineToBr(data.value)" />
            </template>
        </BTable>
    </div>
</template>

<script>
import {hasPermission} from "@/helpers/permissions";
import * as DateHelper from "@/helpers/date";

export default {
    name: 'OrderCommentsHistory',
    computed: {
        DateHelper() {
            return DateHelper
        }
    },

    props: {
        salesOrderIdentifier: {
            type: String,
            required: true,
            default: ""
        },
    },

    data() {
        return {
            isLoading: {
                commentHistory: false,
            },
            commentHistoryFields: [
                {key: 'created_at', label: 'Geplaatst op', sortable: true},
                {key: 'user.name', label: 'Gebruiker'},
                {key: 'comment', label: 'Opmerking'},
            ],
            commentHistory: [],
            sortingOptions: {
                sortDesc: true,
            },
        }
    },

    methods: {
        loadCommentHistory() {
            this.isLoading["commentHistory"] = true

            const endpoint = `/api/rest/sales-orders/${this.salesOrderIdentifier}/comments`;

            this.$http.get(endpoint)
                .then(response => {
                    this.commentHistory = response.data;
                })
                .catch(e => {
                    let errorIdentifier = e.response.data.errors[0].identifier
                    if (errorIdentifier !== "NoDispatchRequestsForUser" || !hasPermission("orders.dispatchrequests.include.reroutedreplaceddispatchrequests")) {
                        console.error(e)
                        this.$alert('Fout bij het ophalen van de opmerkingen', 'danger')
                    }
                })
                .finally(() => {
                    this.isLoading["commentHistory"] = false
                })
        },

        newLineToBr(value) {
            return value.replace(/\n/g, '<br>');
        }
    },

    mounted() {
        this.loadCommentHistory();
    },
}
</script>

<style scoped>
.order-comment-history.limited-height {
    max-height: 30rem;
    overflow-y: scroll;
}
</style>
